const formatterLocal = new Intl.DateTimeFormat('en-CA');

/**
 * Formats a date as "YYYY-MM-DD" in the browser's local timezone.
 *
 * @example
 * // User is in UTC+3, date is 2026-05-26T23:00:00Z (= 2026-05-27 locally)
 * formatYYYYMMDDLocal(new Date('2026-05-26T23:00:00Z')) // → "2026-05-27"
 */
export const formatYYYYMMDDLocal = (date: Date | string): string =>
  formatterLocal.format(new Date(date));
